import React from 'react';
import Product from './Product';
import '../styles/Shop.css';

const products = [
  { id: 1, name: "Bubble Gum", price: 109000.00, image: "/images/product1-img1.png" },
  { id: 2, name: "Ret Vanilla", price: 79000.00, image: "/images/product2-img1.png" },
  { id: 3, name: "Romant Wis", price: 79000.00, image: "/images/product5-img1.png" },
  { id: 4, name: "Vanilla Cake", price: 89000.00, image: "/images/product6-img1.png" },
];

const Shop = () => {
  return (
    <div className="shop container">
      <h1>Our Collection</h1>
      <div className="product-grid">
        {products.map((product) => (
          <Product
            key={product.id}
            id={product.id}
            name={product.name}
            image={product.image}
            price={product.price}
          />
        ))}
      </div>
    </div>
  );
};

export default Shop;